import { useSelector } from 'react-redux'
import cc from 'classcat'

import { useTranslate } from '../../../../../utils/translate'

type Props = {
  config: WorkspacePluginProps['config']
  product: Core.Product
  onDelete: (id: string) => void
}

export default function ProductListEntry({ config, product, onDelete }: Readonly<Props>) {
  const hashedThemeAssets = useSelector<State, ImmutableMap>((state) => state.getIn(['view', 'hashedThemeAssets']))

  const t = useTranslate('interface')

  const thumbnailUrl = config?.thumbnailUrl || ((url) => url)
  const containerClassName = product.isVisible ? '' : 'invisible'

  return (
    <div className={cc(['dali-plugin-productslider-wrapper', containerClassName])}>
      <div
        className="dali-plugin-productslider-image"
        style={{
          backgroundImage: product.image?.url
            ? `url("${thumbnailUrl(product.image.url)}")`
            : `url('/themes/epages.base/assets/images/${hashedThemeAssets.getIn([
                'epages.base/assets/images',
                'placeholder_180.jpg',
              ])}`,
        }}
      />
      <div className="dali-plugin-productslider-sku" title={product.sku}>
        {product.sku}
      </div>
      <div className="dali-plugin-productslider-name" title={product.name}>
        {product.name}
        {!product.isVisible && (
          <span>
            <i
              className="dali-plugin-productslider-icon-invisible"
              title={t('components.productListEntry.invisible')}
            />
          </span>
        )}
      </div>
      <div className="dali-plugin-productslider-price">{product.price?.formatted}</div>
      <div
        className="dali-plugin-productslider-button-delete"
        title={t('components.productListEntry.deleteButton')}
        onClick={() => onDelete(product.productId)}
      />
    </div>
  )
}
